import { Flex } from "@chakra-ui/react";
import { FC } from "react";

const Home: FC = () => {
    return (
        <Flex h='100vh' align='center' fontSize='2xl' p='2rem'>
            Hello, I'm Chance, a full stack engineer.
        </Flex>
    )
};

export default Home;